import { useUserInfo } from "hocs/UserInfoContext";
import { formatRoleLabel, useActAs } from "./useActAs";

/** Always-visible reminder that a super admin is currently acting as an entity user. */
const ActingAsBanner = () => {
  const { actingAs } = useUserInfo();
  const { stopActingAs, busy } = useActAs();

  if (!actingAs) return null;

  return (
    <div
      role="status"
      className="flex items-center justify-between gap-3 px-4 py-1.5 text-xs bg-warning-light text-warning-light-foreground border-b border-warning/30"
    >
      <span>
        You are acting as <span className="font-semibold">{actingAs.name}</span> (
        {formatRoleLabel(actingAs.role)}). Everything you do here is done as that user.
      </span>
      <button
        type="button"
        onClick={stopActingAs}
        disabled={busy}
        className="shrink-0 px-2 py-0.5 rounded border border-warning/40 font-medium hover:bg-warning hover:text-warning-foreground transition-colors duration-150 disabled:opacity-50"
      >
        {busy ? "Switching…" : "Stop acting as"}
      </button>
    </div>
  );
};

export default ActingAsBanner;
